// extracted by mini-css-extract-plugin
module.exports = {"main":"with-related_main__yNj4q","swiperNewRoot":"with-related_swiperNewRoot__caq9w"};